import React from "react";
import Layout from "../../../component/Layout";
import TestHeader from "./TestHeader";
import teststep2 from "../../../images/Teststep2.png";
import strengthLarge from "../../../images/strengthLarge.png";
import testCenterImg from "../../../images/testCenterImg.png";
import playIcon from "../../../images/playIcon.svg";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import { Link } from "react-router-dom";
const TestStep2 = () => {
  return (
    <Layout>
      <div className="relative h-full testbg pb-5 overflow-y-auto">
        <TestHeader />
        <div className="w-full max-w-2xl mx-auto px-5">
          <div className="relative text-center mb-[30px]">
            <p className="text-white text-base font-normal capitalize">
              step 2
            </p>
            <Link to="/tools">
              <span className="absolute left-0 top-1/2 -translate-y-1/2">
                <ArrowL />
              </span>
            </Link>
          </div>
          <Link to="/teststep3" className="w-fit mx-auto block mb-[30px]">
            <div style={{ width: 174, height: 174 }} className=" ">
              <CircularProgressbarWithChildren
                strokeWidth={5}
                value={60}
                styles={buildStyles({
                  textColor: "#000", // Text color
                  pathColor: "#00901E", // Progress path color
                  trailColor: "#454545", // Background path color
                })}
              >
                <img
                  src={testCenterImg}
                  alt="testCenterImg"
                  className="w-[92px] h-[68px] mb-2"
                />
                <span className="text-[#A5A5A5] text-[12px] font-normal leading-[91%] uppercase">
                  LOAD VELOCITY
                </span>
              </CircularProgressbarWithChildren>
            </div>
          </Link>
          <div className="flex flex-col gap-2 mb-10">
            <div className="flex flex-row justify-center gap-12">
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  REPS
                </p>
                <p className="text-white text-sm font-normal">1</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  Distance
                </p>
                <p className="text-white text-sm font-normal">Sprint 30m</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  LOAD
                </p>
                <p className="text-white text-sm font-normal">30lbs</p>
              </div>
            </div>
            <div className="relative w-full max-w-[244px] border-b border-white mx-auto">
              <input
                type="text"
                placeholder="Enter max mph"
                className="bg-transparent w-full outline-none p-[19px_60px_19px_20px] placeholder:text-[#5D5D5D] text-white text-xl font-normal"
              />
              <span className="absolute right-5 top-1/2 -translate-y-1/2">
                <Add />
              </span>
            </div>
          </div>
        </div>
        <div className="w-full max-w-2xl mx-auto">
          <div className="relative h-[210px]">
            <img
              src={strengthLarge}
              alt={strengthLarge}
              className="h-full w-full object-cover"
            />
            <img
              src={playIcon}
              alt="icon"
              className="object-contain absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 cursor-pointer  pb-5"
            />
          </div>
          <div className="bg-black p-5 rounded-t-[20px] relative z-10 -mt-8">
            <p className="text-white text-sm font-normal">
              Lorem ipsum dolor sit amet consectetur. Cras sit eget velit
              tristique dictum justo. Cras mi odio id et maecenas nisl odio
              vitae commodo.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TestStep2;

const ArrowL = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#FFFEFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Add = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
    >
      <path
        d="M10.5 1V21M0.5 11C8.31049 11 12.6895 11 20.5 11"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
